import { useEffect } from "react";
import { useHotelBookingContext } from "@/app/lib/context/HotelBookingContext";
import HotelsList from "@/app/ui/hotels-list/HotelsList";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_hotels/hotels/list")({
  component: RouteComponent,
});

function RouteComponent() {
  const { resetBooking } = useHotelBookingContext();

  useEffect(() => {
    resetBooking();
  }, [resetBooking]);

  return (
    <main className="no-footer main h-screen">
      <HotelsList />
    </main>
  );
}
